import { alertClasses, Components, linkClasses, Theme } from '@mui/material';

export const MuiAlert: Components<Theme>['MuiAlert'] = {
  defaultProps: {
    variant: 'standard',
    severity: 'success',
  },
  styleOverrides: {
    standardError: ({ theme }) => ({
      ...theme.typography.body1,
      backgroundColor: theme.palette.status.error.lowContrast,
      color: theme.palette.status.error.highContrast,
      [`&	.${alertClasses.icon}`]: {
        color: theme.palette.status.error.highContrast,
      },
    }),
    standardInfo: ({ theme }) => ({
      ...theme.typography.body1,
      backgroundColor: theme.palette.status.info.lowContrast,
      color: theme.palette.status.info.highContrast,
      [`&	.${alertClasses.icon}`]: {
        color: theme.palette.status.info.highContrast,
      },
    }),
    standardSuccess: ({ theme }) => ({
      ...theme.typography.body1,
      backgroundColor: theme.palette.status.success.lowContrast,
      color: theme.palette.status.success.highContrast,
      [`&	.${alertClasses.icon}`]: {
        color: theme.palette.status.success.highContrast,
      },
    }),
    standardWarning: ({ theme }) => ({
      ...theme.typography.body1,
      backgroundColor: theme.palette.status.warning.lowContrast,
      color: theme.palette.status.warning.highContrast,
      [`&	.${alertClasses.icon}`]: {
        color: theme.palette.status.warning.highContrast,
      },
    }),
    root: {
      ['& .' + linkClasses.root]: {
        textDecoration: 'underline',
      },
      alignItems: 'center',
    },
    action: {
      padding: 0,
    },
  },
};
